// extracted by mini-css-extract-plugin
export default {"wrapper":"pieChart_wrapper__OEC8-","header":"pieChart_header__SbWq-"};